import { withVersions } from "v2/hocs/withVersions";
import withTradeRowItem from "../hocs/withTradeRowItem";
import TradeRowItemV1 from "./TradeRowItem/v1";
import TradeRowItemV2 from "./TradeRowItem/v2";

const TradeRowItem = withVersions({
  v1: withTradeRowItem(TradeRowItemV1),
  v2: withTradeRowItem(TradeRowItemV2),
});

export default TradeRowItem;
